import React, { Component } from "react";

export default class LogoutTile extends Component {
  render() {
    const { remote_url, onLogout } = this.props;

    return (
      <li>
        <a href={remote_url} className="sideList" onClick={onLogout}>
          <i className="fa fa-sign-out sideIcon" style={{ color: "white" }}></i>
          <span className="sideText">Logout</span>
        </a>
      </li>
    );
  }
}
